'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularOff = function DeviceSignalCellularOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z' })
  );
};
DeviceSignalCellularOff = (0, _pure2.default)(DeviceSignalCellularOff);
DeviceSignalCellularOff.displayName = 'DeviceSignalCellularOff';
DeviceSignalCellularOff.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularOff;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/device/signal-cellular-off.js
 ** module id = 1873
 ** module chunks = 0
 **/